// test2555
(2555 && 0);
